export default "__VITE_ASSET__YxPR7gLH__"